import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  cancelBonus,
  CancelBonusRequest,
  CancelBonusResponse,
} from 'api/payments'
import { paymentKeys } from './keys'

export function useCancelBonusMutation() {
  const queryClient = useQueryClient()
  return useMutation<CancelBonusResponse, Error, CancelBonusRequest>({
    mutationFn: cancelBonus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: paymentKeys.list })
      queryClient.invalidateQueries({
        queryKey: paymentKeys.outstandingBalance,
      })
    },
  })
}
